import React from "react";
import Popup from "reactjs-popup";
import './ReusablePopup.css'

const ReusablePopup = ({ isOpen, onClose, title, message, actions }) => {
  return (
    <Popup open={isOpen} onClose={onClose} modal>
      <div className="reusable-popup">
      <div className="header"> {title} </div>
      <div className="content">
      {message}
      </div>
      <div className="actions">
      {actions}
      </div>
      </div>
    </Popup>
  );
};

export default ReusablePopup;
